{
  "route.actions.title": "行動",
  "actionSetupTierFields.multiplyPointsEnabled.label.points": "多個點數",
  "actionSetupTierFields.multiplyPointsEnabled.label.points.loyalty": "多個點數",
  "actionSetupTierFields.multiplyPointsEnabled.label.points.status": "多個狀態點數",
  "actionSetupTierFields.multiplyPointsEnabled.label.points.balance": "多個可消費的點數",
  "actionSetupTierFields.multiplyPointsEnabled.label.spend": "多個消費獎勵",
  "actionSetupTierFields.multiplyPoints.placeholder": "-- 選擇乘數 --",
  "actionSetupTierFields.pointsEnabled.label.points": "獎金點數",
  "actionSetupTierFields.pointsEnabled.label.points.loyalty": "獎金點數",
  "actionSetupTierFields.pointsEnabled.label.points.status": "獎金狀態點數",
  "actionSetupTierFields.pointsEnabled.label.points.balance": "可消費的獎金點數",
  "actionSetupTierFields.pointsEnabled.label.spend": "額外消費獎勵",
  "actions.addButton.text": "建立此類型的新行動：{actionType}",
  "actionSetup.title.new": "新增：{actionType}",
  "actionSetup.title.edit": "{actionType} 設定 - {actionName}",
  "actionSetup.referralContent.referrer.text": "針對首次使用優惠代碼訂購的每個朋友，您將取得：{token}。",
  "actions.notification.purchase.helpLinkText": "附加",
  "actions.notification.purchase.learnMoreLinkText": "深入瞭解",
  "actions.notification.promotion.learnMoreLinkText": "深入瞭解",
  "actions.notification.promotion": "設定促銷前，請確保查看紀錄文件以瞭解您的設定如何影響客戶體驗。{learnMoreLink}。",
  "actions.notification.engagement.helpLinkText": "附加",
  "actions.notification.engagement.learnMoreLinkText": "深入瞭解",
  "actions.notification.event.learnMoreLinkText": "深入瞭解",
  "actions.notification.event": "若要使事件行動為啟用中，您必須將其連接至自動化計劃。{learnMoreLink}。",
  "actions.notification.referral.learnMoreLinkText": "深入瞭解",
  "actions.notification.referral": "您可為每個市場建立一個推薦行動。{learnMoreLink}。",
  "actions.notification.join.helpLinkText": "附加",
  "actions.notification.join.learnMoreLinkText": "深入瞭解",
  "actionSetup.alert.activeMustDeactivate": "此行動為啟用中且已鎖定其設定。若要編輯此行動，您必須先進行下列行動：{deactivateTag} 並等待過期日期。",
  "actions.deleteAction.tooltip.attachable": "若要刪除行動，您必須先停用行動並等待過期日期。",
  "actions.deleteAction.tooltip.promotion": "若要刪除啟用中促銷行動，您必須先將其停用。",
  "actions.deleteAction.tooltip.event": "若要刪除啟用中事件行動，您必須先將其停用。",
  "actions.reportsIcon.tooltip": "計劃分析",
  "actions.card.subtitle.starttime": "開始日期：{startTime}",
  "actions.card.subtitle.endtime": "結束日期：{endTime}",
  "actions.card.subtitle.nonPromotion.suffix": "行動",
  "actions.card.label.recurring": "週期性",
  "actions.card.label.nonRecurring": "非週期性",
  "actions.masterActions.join.largeText": "加入忠誠",
  "actions.masterActions.purchases.largeText": "購買",
  "actions.masterActions.engagements.largeText": "互動",
  "actions.masterActions.events.largeText": "事件",
  "actions.masterActions.promotions.largeText": "促銷",
  "actions.masterActions.referral.largeText": "推薦",
  "actions.deleteDialog.attachable.title": "您確定要刪除此行動嗎？",
  "actions.deleteDialog.attachable.text": "刪除此行動前，請確保其未連接至自動化計劃。刪除此行動後，便無法再使用。",
  "actions.deleteDialog.promotion.title": "您確定要刪除此促銷嗎？",
  "actions.deleteDialog.promotion.text": "刪除此促銷前，請確保其未連接至自動化計劃。刪除此促銷後，便無法再使用。",
  "actions.deleteDialog.event.title": "您確定要刪除此行動嗎？",
  "actions.deleteDialog.event.text": "刪除此行動前，請確保其未連接至自動化計劃。刪除此行動後，便無法再使用。",
  "actions.deleteDialog.referral.title": "您確定要刪除此計劃嗎？",
  "actions.deleteDialog.referral.text": "刪除此計劃後，便無法使用計劃和其設定。請確保讓成員瞭解無法再使用計劃。",
  "actions.filters.search.label": "搜尋",
  "actions.filters.status.label": "狀態",
  "actions.filters.usageType.label": "使用類型",
  "actions.filters.recurringType.label": "週期性類型",
  "actions.addButton.promotion.text": "建立新促銷",
  "actionSetup.title.default": "預設設定",
  "actionSetup.referralContent.referrer.title": "獎勵您的朋友：",
  "actionSetup.referralContent.referrer.subtitle": "共用您的個人連結：",
  "actionSetup.referralContent.referrer.consentText": "共用您的個人連結，即您同意：",
  "actionSetup.referralContent.referrer.consentLinkText": "條款與條件",
  "actionSetup.alert.promotionEnded": "此促銷已過期，因此無法編輯。您可複製促銷或建立新促銷。",
  "actionSetup.alert.notActivated": "啟用中行動的過期日期：{timeTag}",
  "actionSetup.rewardSetting.notification.purchaseAction": "沒有定義獎勵的層級成員會收到預設訊息，新成員會收到預設註冊訊息和獎勵。",
  "actionSetup.rewardSetting.notification.eventAction": "沒有定義獎勵的層級成員會收到預設訊息。",
  "actionSetup.rewardSetting.notification.promotionAction": "沒有定義獎勵的層級成員會收到預設行動訊息。",
  "actionSetup.actionSettings.notification.engagementAction": "所有互動行動皆由自動化中心計劃觸發。",
  "actionSetup.actionSettings.notification.eventAction": "所有事件行動皆由自動化中心計劃觸發，您定義的獎勵會顯示在忠誠錢包的兌換頁面上。",
  "actionSetup.actionSettings.notification.referralAction": "設定計劃前，請確保建立要連接的觸發電子郵件行銷活動。如果您管理多個語言的計劃，請建立每個語言的範本。<a target=\"_blank\" href=\"https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdeef4f574c11014a278956df7fe0479.html?locale=en-US\">深入瞭解</a>",
  "actionSetup.referralContent.referee.title": "取得您的獎勵！",
  "actionSetup.referralContent.referee.text": "恭喜，您的朋友送了一份禮物給您。",
  "actionSetup.referralContent.referee.secondaryTitle": "輸入要兌換獎勵的電子郵件。",
  "actionSetup.referralContent.referee.secondaryText": "我們使用您的電子郵件以傳送獎勵，確保您取得該獎勵。",
  "actionSetup.referralContent.referee.inputFieldPlaceholder": "輸入您的電子郵件。",
  "actionSetup.referralContent.referee.consentText": "我同意：",
  "actionSetup.referralContent.referee.consentLinkText": "條款與條件",
  "actionSetup.multilangActionNameField.label": "行動名稱",
  "actionSetup.multilangPopup.title": "以語言為基礎的觸發電子郵件行銷活動",
  "actionSetupContentCreation.editSide.notification.contnet": "附加事件行動後，便僅會顯示在忠誠錢包的兌換頁面上。點數會自動新增至成員餘額。",
  "actionSetupContentCreation.editSide.title.text.default": "預設訊息  ",
  "actionSetupContentCreation.editSide.title.text.loyalty": "忠誠訊息",
  "actionSetupContentCreation.editSide.title.text.realtime": "即時通知",
  "actionSetupContentCreation.editSide.title.tooltip.event": "事件行動由自動化中心計劃觸發。定義的獎勵會自動提供給成員，您可在行銷管道中使用定義的權杖。",
  "actionSetupContentCreation.previewSideTitleTooltip.conent": "範例說明定義的行動和獎勵如何在電子郵件內容區塊中顯示。實際設計可能因電子郵件設計而有所不同。",
  "actionSetupContentCreation.nav.loyaltyMessage": "忠誠訊息",
  "actionSetupContentCreation.nav.realtimeMessage": "即時通知",
  "actionSetupContentCreation.preview.title": "預覽",
  "actionSetupContentCreation.previewTabs.tooltip.message": "訊息預覽",
  "actionSetupContentCreation.previewTabs.tooltip.tiers": "層級預覽",
  "actionSetupContentCreation.previewTabs.tooltip.wallet": "錢包預覽",
  "actionSetupGeneral.triggerConnection.tooltip.engagement": "互動行動由自動化中心計劃觸發，請從名單選擇完成此行動所需的所有相關外部事件。",
  "actionSetupGeneral.triggerConnection.tooltip.event": "事件行動由自動化中心計劃觸發，請從名單選擇完成此行動所需的相關外部忠誠事件。",
  "actionSetupGeneral.triggerConnection.label": "外部忠誠事件",
  "actionSetupGeneral.triggerConnection.placeholder": "-- 選擇連線 --",
  "actionSetupGeneral.promotionSetting.promotionTypeRb.label": "促銷類型",
  "actionSetupGeneral.promotionSetting.automaticTargeting.label": "自動目標鎖定",
  "actionSetupGeneral.promotionSetting.automaticTargeting.tooltip": "您可個別使用自動目標鎖定，也可在行銷活動編輯器中推播促銷時始使用。",
  "actionSetupGeneral.promotionSetting.automaticTargeting.showInWalletCb.label": "自動鎖定此促銷的目標相關層級成員，並在忠誠錢包中顯示。",
  "actionSetupGeneral.promotionSetting.automaticTargeting.notification": "即時編輯促銷，並將變更推播至忠誠錢包。這可提供靈活性，但如果您也使用電子郵件推播此促銷，則可能造成不一致。<a href=\"https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea82a574c11014b4ab87b7d9fc9306.html?locale=en-US\" target=\"_blank\">深入瞭解</a>。",
  "actionSetupGeneral.promotionSetting.title": "促銷設定",
  "actionSetupGeneral.actionNameInput.defNoJoin.label": "預設類型",
  "actionSetupGeneral.actionNameInput.referral.label": "計劃名稱",
  "actionSetupGeneral.actionInternalNameInput.referral.label": "內部計劃名稱",
  "actionSetupGeneral.actionNameInput.referral.tooltip": "輸入要在成員的活動歷史記錄中向其顯示的計劃名稱，該名稱也可在內部識別該計劃。",
  "actionSetupGeneral.title": "一般設定",
  "actionSetupGeneral.multiMarketSelect.label": "選擇市場",
  "actionSetupGeneral.multiMarketSelect.tooltip": "在忠誠設定中，語言和幣別索引標籤中定義的市場。您必須為每個市場定義個別計劃，因為計劃和推薦連結僅會在所選市場的忠誠錢包中顯示。您僅可為每個市場設定一個計劃。",
  "actionSetupGeneral.actionTypeSelect.label": "選擇使用案例",
  "actionSetupGeneral.catalogSelectorInput.label": "從目錄中選擇",
  "actionSetupGeneral.catalogSelectorInput.title": "目錄選擇器",
  "actionSetupGeneral.catalogSelectorInput.tooltip": "選擇您要促銷的特定產品、種類或集合。",
  "actionSetupGeneral.defaultJoinInput.label": "預設類型",
  "actionSetupGeneral.defaultJoinInput.value": "預設加入",
  "actionSetupGeneral.descriptionInput.label": "內部說明",
  "actionSetupGeneral.iconSelectInput.label": "圖示",
  "actionSetupGeneral.iconSelectInput.iconText": "新增至行動",
  "actionSetupGeneral.iconSelectInput.tooltip": "選擇向成員顯示的圖示，圖示也會顯示為個人化服務中的忠誠權杖。",
  "actionSetupGeneral.minOrderInput.label": "最低訂單金額",
  "actionSetupGeneral.minOrderInput.tooltip.referral": "如果您定義此值，則推薦的朋友必須在訂單中至少消費此金額，推薦的成員才能取得獎勵。請確保在成員和朋友的推薦訊息中包含此資訊。",
  "actionSetupGeneral.minOrderInput.tooltip.other": "成員必須在訂單中至少消費此金額，才能取得獎勵。請確保在推薦訊息中包含此資訊。",
  "actionSetupGeneral.minOrderDisplayInput.label": "顯示的金額",
  "actionSetupGeneral.minOrderDisplayInput.tooltip": "如果總消費不符合最低訂單金額 (例如扣除第三方費用後)，客戶將看到的金額。",
  "actionSetupGeneral.blockExternalLink.url.label": "外部 URL",
  "actionSetupGeneral.blockExternalLink.url.tooltip": "您可新增 URL 以從忠誠錢包中的行動區塊直接連結至頁面。",
  "actionSetupGeneral.blockExternalLink.text.label": "URL 內文",
  "actionSetupGeneral.blockExternalLink.text.tooltip": "輸入要在忠誠錢包中向成員顯示的此 URL 內文。",
  "actionSetupGeneral.actionNameInput.other.label": "{actionTypeText} 名稱",
  "actionSetupGeneral.actionInternalNameInput.other.label": "{actionTypeText} 內部名稱",
  "actionSetupGeneral.actionNameInput.other.tooltip": "輸入向成員顯示的名稱：{actionTypeText}。名稱也會顯示為個人化服務中的忠誠權杖。",
  "actionSetupLoyaltyMessage.tooltip.members.nonDefault": "此訊息會向成員顯示：{actionTypeText}。此權杖包含獎勵權杖。",
  "actionSetupLoyaltyMessage.ctaButton.tooltip": "此行動呼籲用於忠誠錢包中兌換頁面上的所有輸入項。",
  "actionSetupLoyaltyMessage.ctaButton.label": "行動呼籲",
  "actionSetupLoyaltyMessage.ctaUrl.label": "行動呼籲 URL",
  "actionSetupLoyaltyMessage.ctaUrl.tooltip.eventAction": "行動呼籲 URL 可使用作為管道中的個人化權杖，但無法在錢包中或透過 API 使用。",
  "actionSetupLoyaltyMessage.header.members": "成員",
  "actionSetupLoyaltyMessage.header.nonMembers": "非成員",
  "actionSetupLoyaltyMessage.label.join": "加入訊息",
  "actionSetupLoyaltyMessage.label.other": "訊息",
  "actionSetupLoyaltyMessage.tooltip.nonmembers.hasRewardForNonMembers": "您已定義獎勵，預設訊息將顯示在此處。您可編輯獎勵和訊息。",
  "actionSetupLoyaltyMessage.tooltip.nonmembers.noRewardForNonMembers": "您未定義新成員的獎勵，因此預設加入訊息和獎勵會顯示在此處，但無法編輯。",
  "actionSetupLoyaltyMessagePreviewEmail.notification.contentMode": "範例說明定義的行動和獎勵如何在電子郵件內容區塊中顯示。實際設計可能因電子郵件設計而有所不同。",
  "actionSetupLoyaltyMessageTokens.notification.content": "內容編輯器中的所有管道可用的忠誠權杖名單。",
  "actionSetupRealtimeNotification.content.notification.url.label": "即時網站通知 URL",
  "actionSetupRealtimeNotification.content.notification.url.tooltip": "輸入通知顯示的頁面 URL。",
  "actionSetupRealtimeNotification.content.notification.limitOfUse.label": "限制使用",
  "actionSetupRealtimeNotification.content.notification.limitOfUse.tooltip": "選擇要此通知顯示的頻率。",
  "actionSetupReferralContent.title": "推薦表單",
  "actionSetupReferralContent.translateForm.label": "翻譯表單 ",
  "actionSetupReferralContent.translateForm.tooltip": "表單翻譯為選用。如果無法使用翻譯，則表單會以忠誠設定中定義的預設語言向成員顯示。",
  "actionSetupReferralContent.preview": "預覽",
  "actionSetupRewards.pointsType.title": "獎勵點數類型",
  "actionSetupRewards.pointsType.tooltip": "定義完成行動的授予點數類型。",
  "actionSetupRewards.pointsType.popup.title": "您確定嗎？",
  "actionSetupRewards.title": "獎勵",
  "actionSetupRewards.tooltip": "定義此行動贏得的獎勵。",
  "actionSetupRewards.accordionTierItem.tooltip.all.disabled": "針對此行動，無法提供下列點數類型的「多個點數」：{pointType}。下列層級預設不支援此點數類型：({tierNames})。請更新這些層級，或選擇其他獎勵類型。",
  "actionSetupRewards.accordionTierItem.tooltip.tier.disabled": "由於此層級不支援下列基本購買的點數類型，因此無法提供「多個點數」獎勵：{pointType}",
  "actionSetupRewards.accordionTierItem.tooltip.pointType.status": "狀態點數",
  "actionSetupRewards.accordionTierItem.tooltip.pointType.balance": "消費點",
  "actionSetupRewards.subtitle.members": "忠誠成員獎勵",
  "actionSetupRewards.subtitle.friends": "朋友獎勵",
  "actionSetupRewards.subtitle.friends.tooltip": "此內容中的「朋友」指的是收到忠誠成員推薦的任何人。",
  "actionSetupRewards.accordionTierItem.tooltip.non": "除了加入忠誠計劃的標準獎勵外，成員購買的額外獎勵。",
  "actionSetupRewards.accordionTierItem.tooltip.all": "這會覆寫個別層級獎勵。",
  "actionSetupRewards.referralLimitations.codes.type.title": "限制推薦代碼",
  "actionSetupRewards.referralLimitations.codes.type.tooltip": "限制忠誠成員可在一年中向朋友傳送的代碼數量。此設定可協助減少濫用風險。",
  "actionSetupRewards.referralLimitations.rewards.type.label": "限制推薦獎勵",
  "actionSetupRewards.referralLimitations.rewards.type.tooltip": "限制忠誠成員可在一年中取得推薦獎勵的次數。",
  "actionTypeOptions.purchase.name": "提升購買",
  "actionTypeOptions.promotioEvent.name": "銷售/事件",
  "actionTypeOptions.promotioCatalog.name": "目錄促銷",
  "actionTypeOptions.engagement.name": "提升互動",
  "actionTypeOptions.event.name": "週年/福利日",
  "actionTypeOptions.redemption.name": "提升點數兌換",
  "actionTypeOptions.referral.name": "推薦",
  "actionTypeOptions.join.name": "加入忠誠計劃",
  "defaultActionTypeOptions.join.name": "加入忠誠計劃/忠誠預設",
  "defaultActionTypeOptions.purchases.name": "購買/忠誠預設",
  "defaultActionTypeOptions.promotionEvent.name": "銷售/事件",
  "defaultActionTypeOptions.promotionCatalog.name": "目錄促銷",
  "defaultActionTypeOptions.engagements.name": "互動/忠誠預設",
  "defaultActionTypeOptions.events.name": "獎金/忠誠預設",
  "defaultActionTypeOptions.redemption.name": "兌換/忠誠預設",
  "actionSetupScheduling.rewardsAllocationDelay.duration.tooltip.NoDelay": "已在計劃設定中定義。",
  "actionSetupScheduling.rewardsAllocationDelay.duration.tooltip.withDelay": "選擇成員完成行動後多久將獎勵新增至成員忠誠錢包。",
  "actionSetupScheduling.activationTooltip.promotionDispalyedInWallet": "如果您停用此促銷，則會從忠誠錢包刪除，在將其再次啟用前，您無法在所有管道上使用促銷。",
  "actionSetupScheduling.activationTooltip.referral": "如果您停用計劃，則推薦連結不再有效，並在將其重新啟用前將凍結忠誠錢包中的推薦種類。如果已將兌換券代碼提供給朋友，則在過期日期前仍有效。",
  "actionSetupScheduling.activationTooltip.default": "如果您停用此行動，則在將其啟用前無法再於所有管道上進行分配。如果此行動連接至自動化計劃，則自動化計劃將失敗。如果已將行動提供給客戶，則在過期日期前仍有效。",
  "actionSetupScheduling.title": "正在排程",
  "actionSetupScheduling.rewardsAllocationDelay.duration.label": "獎勵分配延遲",
  "actionSetupScheduling.voucherObjective.label": "兌換券目標",
  "actionSetupScheduling.voucherObjective.tooltip": "選擇成員可兌換此行動兌換券的時間。",
  "actionSetupScheduling.recurringType.label": "週期性類型",
  "actionSetupScheduling.recurringType.tooltip": "選擇促銷為週期性或一次性使用。",
  "actionSetupScheduling.recurringType.oneTime": "一次性使用",
  "actionSetupScheduling.recurringType.recurring": "週期性",
  "actionSetupScheduling.recurring.startDate.label": "開始日期",
  "actionSetupScheduling.recurring.startDate.tooltip": "成員可從定義開始日期開始取得此獎勵。在促銷為啟用中前，您可變更開始日期。",
  "actionSetupScheduling.recurring.endDate.label": "結束日期",
  "actionSetupScheduling.recurring.endDate.tooltip": "成員僅可在您定義的結束日期前取得此獎勵。在促銷過期前，您可變更結束日期。",
  "actionSetupScheduling.recurring.repeatInterval.label": "每",
  "actionSetupScheduling.recurring.repeatInterval.tooltip": "選擇促銷是每日、每週還是每月重複，以及您要重複的頻率。例如，每 2 個月。",
  "actionSetupScheduling.recurring.repeatInterval.options.daily": "天",
  "actionSetupScheduling.recurring.repeatInterval.options.weekly": "週",
  "actionSetupScheduling.recurring.repeatInterval.options.monthly": "月",
  "actionSetupScheduling.recurring.monthly.weekday.short.1": "一",
  "actionSetupScheduling.recurring.monthly.weekday.short.2": "二",
  "actionSetupScheduling.recurring.monthly.weekday.short.3": "三",
  "actionSetupScheduling.recurring.monthly.weekday.short.4": "四",
  "actionSetupScheduling.recurring.monthly.weekday.short.5": "五",
  "actionSetupScheduling.recurring.monthly.weekday.short.6": "六",
  "actionSetupScheduling.recurring.monthly.weekday.short.7": "日",
  "actionSetupScheduling.recurring.monthly.weekday.name.1": "星期一",
  "actionSetupScheduling.recurring.monthly.weekday.name.2": "星期二",
  "actionSetupScheduling.recurring.monthly.weekday.name.3": "星期三",
  "actionSetupScheduling.recurring.monthly.weekday.name.4": "星期四",
  "actionSetupScheduling.recurring.monthly.weekday.name.5": "星期五",
  "actionSetupScheduling.recurring.monthly.weekday.name.6": "星期六",
  "actionSetupScheduling.recurring.monthly.weekday.name.7": "星期日",
  "actionSetupScheduling.recurring.monthly.week.name.1": "第一個",
  "actionSetupScheduling.recurring.monthly.week.name.2": "第二個",
  "actionSetupScheduling.recurring.monthly.week.name.3": "第三個",
  "actionSetupScheduling.recurring.monthly.week.name.4": "第四個",
  "actionSetupScheduling.recurring.monthly.week.name.5": "最後一個",
  "actionSetupScheduling.recurring.monthly.calendarDates.label": "選擇您要獎勵重複的天數：",
  "actionSetupScheduling.recurring.monthly.calendarDates.tooltip": "設定每天成員可取得此獎勵。例如每月的第一天。如果選擇 31，則獎勵一律在每月的最後一天。 ",
  "actionSetupScheduling.recurring.monthly.calendarDates.lastDaysTooltip": "僅當月包含此天時才有效",
  "actionSetupScheduling.recurring.monthly.calendarDates.lastDaysTooltipActive": "僅當這是當月的最後一天時才有效",
  "actionSetupScheduling.recurring.monthly.calendarDates.lastDaysTooltipActiveSelected": "僅當月包含此天或這是當月的最後一天時才有效",
  "actionSetupScheduling.recurring.monthly.weekDays.label": "選擇週數和工作日：",
  "actionSetupScheduling.recurring.monthly.weekDays.tooltip": "成員可在所選日取得此獎勵，例如每月的第一個星期一和星期四。",
  "actionSetupScheduling.recurring.monthly.isLastDayCb.label": "當月的最後一天",
  "actionSetupScheduling.recurring.timeRange": "從 {hour}至 {hour}",
  "actionSetupScheduling.recurring.timeRange.tooltip": "定義成員可取得此獎勵的期間",
  "actionSetupScheduling.recurring.wholeDayCb.label": "全天",
  "actionSetupScheduling.recurring.wholeDayCb.tooltip": "成員可在定義的結束日期前取得此獎勵。在促銷過期前，您可變更結束日期。",
  "actionSetupScheduling.recurring.recurrenceSettings.label": "週期設定",
  "actionSetupScheduling.recurring.summary.label": "摘要",
  "actionSetupScheduling.nonRecurring.summary": "促銷的生效日期為 {startDate} – {endDate}。",
  "actionSetupScheduling.nonRecurring.summary.noSelection": "促銷的生效日期為 {specifyPromoValidity}",
  "actionSetupScheduling.nonRecurring.summary.specifyPromoValidity": "指定促銷有效性。",
  "actionSetupScheduling.recurring.summary.daily": "促銷從 {startDate} 開始並於 {endDate} 結束。促銷在此期間有效：{intervalText}、{hours}。",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.zero": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.one": "每天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.two": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.few": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.many": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.other": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.weekly": "促銷從 {startDate} 開始並於 {endDate} 結束。促銷在此期間有效：{intervalText}、{selectedDays}、{hours}。",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.zero": "每 {numberOfDays} 週",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.one": "每週",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.two": "每 {numberOfDays} 週",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.few": "每 {numberOfDays} 週",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.many": "每 {numberOfDays} 週",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.other": "每 {numberOfDays} 週",
  "actionSetupScheduling.recurring.summary.monthly": "促銷從 {startDate} 開始並於 {endDate} 結束。促銷在此期間有效：{intervalText}、{selectedDays}、{hours}。",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.zero": "每 {numberOfDays} 個月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.one": "每月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.two": "每 {numberOfDays} 個月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.few": "每 {numberOfDays} 個月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.many": "每 {numberOfDays} 個月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.other": "每 {numberOfDays} 個月",
  "actionSetupScheduling.recurring.summary.selectStartDate": "選擇開始日期",
  "actionSetupScheduling.recurring.summary.selectEndDate": "選擇結束日期",
  "actionSetupScheduling.recurring.summary.selectStartHour": "選擇開始小時",
  "actionSetupScheduling.recurring.summary.selectEndHour": "選擇結束小時",
  "actionSetupScheduling.recurring.summary.allDay": "全天",
  "actionSetupScheduling.recurring.summary.betweenHours": "介於小時：{startHour} – {endHour}",
  "actionSetupScheduling.recurring.summary.everyDay": "每天",
  "actionSetupScheduling.recurring.summary.everyWeekNumber": "每 {weekNumber} 週",
  "actionSetupScheduling.recurring.summary.followingDays.singleDay": "在後續數天：{weekNumber} {days}",
  "actionSetupScheduling.recurring.summary.followingDays.multipleDays": "在後續數天：{weekNumber} {days} 和 {lastDay}",
  "actionSetupScheduling.recurring.summary.followingDays.noSelection": "在後續數天：{weekNumber} {selectText}",
  "actionSetupScheduling.recurring.summary.selectDays": "選擇適用天數",
  "actionSetupScheduling.recurring.summary.lastDayOfTheMonth": "當月的最後一天",
  "actionSetupScheduling.recurringType.recurring.tzMismatchNotifiation": "已根據下列時區設定促銷：{timezone}。因此，對開始和結束時間的變更將根據時區考慮。",
  "actionSetupScheduling.promoValidity.label": "促銷有效性",
  "actionSetupScheduling.promoValidity.tooltip": "成員可在定義期間取得此獎勵。",
  "actionSetupScheduling.validityType.label": "行動有效性",
  "actionSetupScheduling.validityType.tooltip": "選擇此行動的有效性類型。",
  "actionSetupScheduling.validity.duration.label": "行動有效性長度",
  "actionSetupScheduling.validity.duration.tooltip": "設定自傳送至成員日期起的此行動有效時間長度。",
  "actionSetupScheduling.validityFixedDate.label": "選擇行動過期日期",
  "actionSetupScheduling.referralCta.label": "行動呼籲",
  "actionSetupScheduling.referralCta.tooltip": "當推薦朋友提供有效的電子郵件地址並選擇 [行動呼籲] 按鈕時，才會發生此行動。",
  "actionSetupScheduling.referralCta.sendViaEmailCb.label": "透過電子郵件傳送代碼。",
  "actionSetupScheduling.referralCta.displayInPopupCb.label": "在彈出視窗方塊中顯示代碼。",
  "actionSetupScheduling.referralCta.sendViaEmail.emailCampaignId.label": "觸發的電子郵件行銷活動",
  "actionSetupScheduling.referralCta.sendViaEmail.emailCampaignId.tooltip": "觸發的電子郵件會將兌換券代碼傳送至推薦朋友。選擇您要連接至此計劃的觸發電子郵件行銷活動。如果您在定義市場中管理多個語言，請選擇每個語言的行銷活動。",
  "actionSetupScheduling.activation.label": "啟用",
  "actionSetupTierFields.pointsEnabled.tooltip.spend": "在此處輸入的值將作為獎勵新增至成員消費獎勵餘額。",
  "actionSetupTierFields.points.placeholder.points": "輸入點數",
  "actionSetupTierFields.points.placeholder.spend": "輸入消費獎勵總和",
  "actionSetupTierFields.rewardPoolEnabledCb.label": "兌換券",
  "actionSetupTierFields.rewardPool.placeholder": "-- 選擇兌換券 --",
  "actionSetupTierFields.exclusiveAccessEnabledCb.label": "專屬存取",
  "actionSetupTierFields.exclusiveAccess.placeholder": "-- 選擇存取 -- ",
  "actionSetupTierFields.statusUpgradeEnabledCb.label": "狀態升級",
  "actionSetupTierFields.statusUpgrade.placeholder": "-- 選擇升級類型 --",
  "multiCurrencyMinOrderFields.alert.message": "輸入所有幣別的最低訂單金額。",
  "multiCurrencyMinOrderFields.minOrderMC.label": "最低訂單金額",
  "multiCurrencyMinOrderFields.minOrderDisplayMC.label": "顯示金額",
  "multiLangEmailCampaignIdField.emailCampaignId.label": "觸發的電子郵件行銷活動",
  "multiLangEmailCampaignIdField.emailCampaignId.placeholder": "-- 選擇範本 --",
  "referralContentReferrerForm.header": "成員",
  "referralContentReferrerForm.tooltip": "此表單會在忠誠錢包中向成員顯示，請確保訊息包含您設定的推薦限制。",
  "referralContentReferrerForm.text": "獎勵內文",
  "referralContentReferrerForm.title1": "獎勵標題",
  "referralContentReferrerForm.title2": "獎勵連結內文",
  "referralContentReferrerForm.landingPageUrl.label": "獎勵連結頁面 URL",
  "referralContentReferrerForm.landingPageUrl.tooltip": "輸入要在朋友選擇推薦連結時顯示的推薦頁面 URL。",
  "referralContentReferrerForm.header.sharingChannels": "共用管道",
  "referralContentReferrerForm.header.sharingChannels.tooltip": "選擇要顯示的共用管道。",
  "referralContentReferrerForm.consentText.label": "同意書內文",
  "referralContentReferrerForm.consentText.tooltip": "檢查同意書是否包含推薦計劃的清楚說明、流程，以及朋友資料是否僅用於處理獎勵而不會儲存。",
  "referralContentReferrerForm.consentLinkText.label": "條款連結內文",
  "referralContentReferrerForm.consentLinkUrl.label": "條款連結頁面 URL",
  "referralContentRefereeForm.header": "朋友",
  "referralContentRefereeForm.header.tooltip": "這是朋友在按一下推薦連結後看到的表單。請確保訊息包含已設定的限制。",
  "referralContentRefereeForm.title1": "獎勵標題",
  "referralContentRefereeForm.text1": "獎勵內文",
  "referralContentRefereeForm.title2": "請求電子郵件標題",
  "referralContentRefereeForm.text2": "請求電子郵件內文",
  "referralContentRefereeForm.inputFieldPlaceholder": "電子郵件欄位",
  "referralContentRefereeForm.consentText.label": "同意書內文",
  "referralContentRefereeForm.consentText.tooltip": "檢查同意書是否包含推薦計劃的清楚說明、流程，以及朋友資料是否僅用於處理獎勵而不會儲存。",
  "referralContentRefereeForm.consentLinkText": "條款連結內文",
  "referralContentRefereeForm.consentLinkUrl": "條款連結頁面 URL",
  "promotionType.oneTime.name": "一次性優惠",
  "promotionType.oneTime.tooltip": "成員僅可兌換此優惠一次。",
  "promotionType.multiUse.name": "多次使用優惠",
  "promotionType.multiUse.tooltip": "成員可在有效期間兌換此優惠多次。",
  "referralCodesLinitOptions.none.name": "無限制",
  "referralCodesLinitOptions.begOfYear.name": "將每年代碼次數限制為：",
  "referralCodesLinitOptions.begOfYear.tooltip": "限制會從行事曆的開頭回溯。",
  "referralRewardLimitOptions.none.name": "無限制",
  "referralRewardLimitOptions.begOfYear.name": "將每個成員的獎勵限制為",
  "referralRewardLimitOptions.begOfYear.tooltip": "限制會從行事曆的開頭回溯。",
  "validityType.limitedFromEarn.name": "行動自傳送至成員起的有效期間為數天。",
  "validityType.fixedDate.name": "針對所有成員，在特定日期前行動都有效。",
  "actionValidator.name.presence.isReferralAction": "輸入計劃名稱。",
  "actionValidator.internalName.presence.isReferralAction": "輸入計劃內部名稱。",
  "actionValidator.name.presence.notReferralAction": "輸入行動名稱。",
  "actionValidator.internalName.presence.notReferralAction": "輸入行動內部名稱。",
  "actionValidator.name.exclusionIgnoreCase": "此名稱已存在，請輸入唯一名稱。",
  "actionValidator.promotion.catalogSelection.actionCatalogSelection": "需要目錄選擇。",
  "actionValidator.constraints.apiTriggers.presence": "選擇外部忠誠事件。",
  "actionValidator.constraints.minOrder.presence": "輸入所有幣別的最低訂單金額。",
  "actionValidator.constraints.minOrderMC.multiLangField": "輸入所有幣別的最低訂單金額。",
  "actionValidator.constraints.blockExternalLink.text.presence": "輸入頁面 URL 內文。",
  "actionValidator.constraints.blockExternalLink.url.presence": "輸入外部頁面 URL。",
  "actionValidator.constraints.blockExternalLink.url.url": "輸入有效的登陸頁面 URL。",
  "actionValidator.constraints.market.presence": "輸入市場。",
  "actionValidator.reward.value.actionSingleReward": "輸入缺少資訊。",
  "actionValidator.constraints.isBlockMessage.isBlockMessage.emptyTokenMessage": "下列為必要欄位：{fieldName}。",
  "actionValidator.constraints.url": "下列欄位必須包含有效 URL：{fieldName}。",
  "actionValidator.constraints.referralLimitations.codes.amount.presence": "輸入推薦限制。",
  "actionValidator.constraints.referralContent.referrer.title.presence": "輸入推薦標題。",
  "actionValidator.constraints.referralContent.referrer.text.emptyTokenMessage": "輸入推薦內文。",
  "actionValidator.constraints.referralContent.referrer.subtitle.presence": "輸入推薦連結內文。",
  "actionValidator.constraints.referralContent.referrer.landingPageUrl.presence": "輸入推薦頁面 URL。",
  "actionValidator.constraints.referralContent.referrer.landingPageUrl.url": "輸入推薦頁面的有效 URL。",
  "actionValidator.constraints.referralContent.referrer.consentText.presence": "輸入同意書內文。",
  "actionValidator.constraints.referralContent.referrer.consentLinkText.presence": "輸入條款連結內文。",
  "actionValidator.constraints.referralContent.referrer.consentLinkUrl.presence": "輸入條款連結頁面 URL。",
  "actionValidator.constraints.referralContent.referrer.consentLinkUrl.url": "輸入有效條款連結頁面 URL。",
  "actionValidator.constraints.referralContent.referee.title.presence": "輸入推薦標題。",
  "actionValidator.constraints.referralContent.referee.text.presence": "輸入獎勵內文。",
  "actionValidator.constraints.referralContent.referee.secondaryTitle.presence": "輸入推薦電子郵件標題。",
  "actionValidator.constraints.referralContent.referee.inputFieldPlaceholder.presence": "輸入電子郵件提示內文。",
  "actionValidator.constraints.referralContent.referee.secondaryText.presence": "輸入推薦電子郵件內文。",
  "actionValidator.constraints.referralContent.referee.consentText.presence": "輸入同意書內文。",
  "actionValidator.constraints.referralContent.referee.consentLinkText.presence": "輸入條款連結內文。",
  "actionValidator.constraints.referralContent.referee.consentLinkUrl.presence": "輸入條款連結頁面 URL。",
  "actionValidator.constraints.referralContent.referee.consentLinkUrl.url": "輸入有效條款連結頁面 URL。",
  "actionValidator.constraints.referralContent.referee.ctaText.presence": "輸入兌換內文。",
  "actionValidator.constraints.referralContent.referee.secondaryConsentText.presence": "輸入次要同意書內文。",
  "actionValidator.constraints.referralContent.referee.secondaryConsentLinkText.presence": "輸入條款連結內文。",
  "actionValidator.constraints.referralContent.referee.secondaryConsentLinkUrl.presence": "輸入條款連結頁面 URL。",
  "actionValidator.constraints.referralContent.referee.secondaryConsentLinkUrl.url": "輸入有效條款連結頁面 URL。",
  "actionValidator.constraints.rcheduling.promoValidity.dateRange.messageEmpty": "輸入促銷有效性日期。",
  "actionValidator.constraints.rcheduling.promoValidity.dateRange.messageRangeNotValid": "促銷至少需要 10 分鐘。",
  "actionValidator.constraints.scheduling.promoValidity.dateRange.selectedDateNotValid": "促銷有效性無效。",
  "actionValidator.constraints.rscheduling.validity.duration.presence": "輸入數字大於零的行動有效性。",
  "actionValidator.constraints.rscheduling.validity.duration.numericality.notInteger": "輸入數字大於零的行動有效性。",
  "actionValidator.constraints.rscheduling.validity.duration.numericality.notGreaterThan": "輸入數字大於零的行動有效性。",
  "actionValidator.constraints.scheduling.validityFixedDate.presence": "輸入過期日期。",
  "actionValidator.constraints.scheduling.referralCta.atLeastOneSelected": "需要 CTA 行動",
  "actionValidator.constraints.scheduling.recurring.startDate.presence": "輸入開始日期",
  "actionValidator.constraints.scheduling.recurring.endDate.presence": "輸入結束日期",
  "actionValidator.constraints.scheduling.recurring.endDate.rangeInvalid": "結束日期不可早於所選開始日期。",
  "actionValidator.constraints.scheduling.recurring.endHour.rangeInvalid": "選擇有效結束時間，結束時間必須晚於開始時間。",
  "actionValidator.constraints.scheduling.recurring.weekDays.presence": "您必須選擇工作日",
  "actionValidator.constraints.scheduling.recurring.monthDays.presence": "您必須選擇月份日期",
  "actionValidator.constraints.emailCampaignId.presence": "輸入觸發的電子郵件行銷活動。",
  "actionValidator.constraints.notDefault.validateNonMember": "定義加入獎勵。",
  "actionValidator.constraints.notDefault.notValidateNonMember": "定義至少一個層級的獎勵。",
  "actionValidator.constraints.notDefault.reward.value.actionRewardSpecificTier": "定義朋友的獎勵。",
  "actionValidator.constraints.currencies.minOrderMC.currency.presence": "輸入所有幣別的最低訂單金額。",
  "form.Steps.actionSettings.title.referral": "計劃設定",
  "form.steps.actionSettings.title": "行動設定",
  "form.steps.rewardSettings.title": "獎勵設定",
  "form.steps.contentCreation.title": "建立內容",
  "form.steps.scheduling.title": "正在排程",
  "form.steps.actionSettings.defaultJoin.title": "預設設定",
  "specialTierRewardSettings.all.name": "所有層級設定相同",
  "specialTierRewardSettings.non.name": "加入獎勵",
  "specialTierRewardSettings.guest.name": "朋友",
  "multiplyPoints.options.double.name": "雙倍點數",
  "multiplyPoints.options.triple.name": "三倍點數",
  "multiplySpend.options.double.name": "雙倍消費獎勵",
  "multiplySpend.options.triple.name": "三倍消費獎勵",
  "statusUpgrade.options.nextTier.name": "升級至下一個層級",
  "enableInSmartBox.options.yes.name": "自動排列優先順序並分配此行動。",
  "enableInSmartBox.options.no.name": "不要自動排列優先順序並分配此行動。",
  "voucherObjective.options.reward.name": "獎勵 (客戶在核准購買後取得獎勵)",
  "voucherObjective.options.trigger.name": "觸發 (客戶立即取得並可透過購買兌換)",
  "activate.options.true": "啟用行動",
  "activate.options.false": "停用行動",
  "activate.promotion.options.true": "啟用促銷",
  "activate.promotion.options.false": "停用促銷",
  "defaultJoinMessageNoReward": "立即加入我們的忠誠計劃並在未來購買取得點數。",
  "selectedPromotion.options.event.name": "銷售/事件促銷",
  "selectedPromotion.options.catalog.name": "目錄促銷",
  "actionDashboard.overviewLinkText.referral": "移至推薦行動",
  "actionDashboard.editLinkText": "編輯計劃",
  "actionDashboard.launchedAt": "計劃已於 {time} 啟動",
  "defaultJoinMessageWithReward": "立即加入我們的忠誠計劃，取得下列獎勵並在未來購買取得點數：{{rewardToken}}",
  "actions.notification.purchase": "若要啟用購買行動，{helpLink} 行動至您的聯絡人。{learnMoreLink}",
  "actions.notification.engagement": "若要啟用互動行動，{helpLink} 行動至您的聯絡人。{learnMoreLink}",
  "actions.notification.join": "預設加入行動啟用後且計劃啟動後，便會自動生效。其他加入行動需要是 {helpLink}。{learnMoreLink}",
  "actionSetup.alert.activeMustDeactivate.deactivateText": "停用",
  "actionSetupContentCreation.editSide.title.tooltip.default": "若發生系統或網路錯誤，則預設訊息會取代原始訊息權杖。定義的 {message} {cta text} {cta url} 權杖會顯示於智慧區塊和忠誠錢包中。",
  "actionSetupContentCreation.editSide.title.tooltip.join": "定義的 {message} {cta text} {cta url} 權杖會顯示於智慧區塊和忠誠錢包中。沒有定義的加入訊息時，將顯示預設訊息。",
  "actionSetupContentCreation.editSide.title.tooltip.other": "定義的 {message} {cta text} {cta url} 權杖會顯示於智慧區塊和忠誠錢包中。您可個別使用這些權杖，或在行銷活動編輯器中與內容區塊一併使用。",
  "actionSetupContentCreation.previewSideTitleTooltip.tokens": "範例說明 {loyalty tokens} 如何在電子郵件內容區塊中顯示。實際設計可能因電子郵件設計而有所不同。",
  "actionSetupLoyaltyMessagePreviewEmail.notification.tokens": "範例說明 {loyalty tokens} 如何在電子郵件內容區塊中顯示。實際設計可能因電子郵件設計而有所不同。",
  "actionSetupRewards.pointsType.popup.message": "若您變更點數類型，則將移除「多個點數」選項，因為層級 {tiers} 的多倍獎勵與您所選的點數類型不相容！若要指定多個點數，您可變更點數類型並再次選擇「多個點數」。",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.zero": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.one": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.two": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.few": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.many": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.other": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.week.name.1": "第一",
  "actionSetupScheduling.recurring.summary.week.name.2": "第二",
  "actionSetupScheduling.recurring.summary.week.name.3": "第三",
  "actionSetupScheduling.recurring.summary.week.name.4": "第四",
  "actionSetupScheduling.recurring.summary.week.name.5": "最後一個"
}
